module.exports = __webpack_public_path__ + "static/img/110_TO8_1808.4f3c7f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/110_TO8_1808.jpg
// module id = G0ZU
// module chunks = 0